import { ApiLinkModel } from '@/client';

export const isExternalLink = (link: ApiLinkModel) => {
  if (link) {
    const { url } = link;
    return (
      url &&
      (url.toLowerCase().startsWith('http://') ||
        url.toLowerCase().startsWith('https://') ||
        url.toLowerCase().startsWith('//') ||
        url.toLowerCase().startsWith('mailto:'))
    );
  }
  return true;
};

export const openLink = (router: any, link: ApiLinkModel) => {
  if (link) {
    const { url, target } = link;
    if (!url) return;
    if (target && target === '_blank') {
      window.open(url, '_blank')?.focus();
    } else if (isExternalLink(link)) {
      window.location.href = url;
    } else {
      router.push(url);
    }
  }
};

export const isValidHttpUrl = (string: string) => {
  let url = null;

  if (string && string.length > 0) {
    try {
      url = new URL(string);
    } catch (e) {
      if (!e) console.trace(e);
      return false;
    }
  } else {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

// convert absolute URLs to relative if same host
export const convertAbsoluteLinkToRelative = (link: ApiLinkModel) => {
  if (link && link.url && isExternalLink(link)) {
    let currentHost = null;
    let currentHostUrl = null;
    if (process.env.NODE_ENV === 'development') {
      currentHost =
        (process.env.DEV_FRONTEND_HOST !== '' && process.env.DEV_FRONTEND_HOST) || 'https://base.matterofform.com/';
    } else {
      if (typeof window === 'undefined') {
        currentHost = process.env.RESOURCE_PATH;
      } else {
        currentHost = window?.location?.origin;
      }
    }

    if (currentHost) {
      try {
        currentHostUrl = new URL(currentHost);
      } catch (e) {
        console.warn('Invalid URL: ' + currentHost, e);
      }

      if (currentHostUrl) {
        let linkUrl = null;

        if (link.url) {
          try {
            linkUrl = new URL(link.url);
          } catch (e) {
            console.warn('Invalid URL: ' + link.url, e);
          }
          if (linkUrl) {
            if (currentHostUrl.host === linkUrl.host) {
              return { ...link, href: linkUrl.pathname + linkUrl.search };
            }
          }
        }
      }
    }
  }
  return link;
};

export const getUrlExtension = (url: string) => {
  return url.split(/[#?]/)[0].split('.').pop()?.trim().toLowerCase();
};
